import { STATUS_AVALIACAO_LABELS, STATUS_PRAZO_LABELS } from '../../utils/acreditacaoOpcoes';

const TONES = {
  // status de avaliação
  supera: 'pill-dark',
  conforme: 'pill-success',
  parcialmente_conforme: 'pill-warning',
  nao_conforme: 'pill-danger',
  // farol de prazo
  em_dia: 'pill-success',
  a_vencer: 'pill-warning',
  vencido: 'pill-danger',
  // genéricos
  ativo: 'pill-success',
  aprovado: 'pill-success',
  inativo: 'pill-outline',
  pendente: 'pill-warning',
  recusado: 'pill-danger',
  cancelado: 'pill-danger',
};

const LABELS = {
  ativo: 'Ativo',
  aprovado: 'Aprovado',
  inativo: 'Inativo',
  pendente: 'Pendente',
  recusado: 'Recusado',
  cancelado: 'Cancelado',
  ...STATUS_AVALIACAO_LABELS,
  ...STATUS_PRAZO_LABELS,
};

export default function StatusBadge({ status }) {
  const tone = TONES[status] || 'pill-outline';
  const label = LABELS[status] || status;
  return <span className={`pill ${tone}`}>{label}</span>;
}
